import React, { useEffect, Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Indexes from './pages/Indexes';
import Reports from './pages/Reports';
import ChartSimulator from './pages/ChartSimulator';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

import { checkAuthVersion, refreshUserPermissions, initSessionTracking } from './services/api';

const DevPreview = lazy(() => import('./pages/DevPreview'));
const DevPreviewJump = lazy(() => import('./pages/DevPreviewJump'));
const DevPreviewBestTrades = lazy(() => import('./pages/DevPreviewBestTrades'));
const DevPreviewCompare = lazy(() => import('./pages/DevPreviewCompare'));
const DevPreviewSignalBrief = lazy(() => import('./pages/DevPreviewSignalBrief'));
const DevPreviewSignalAnalysis = lazy(() => import('./pages/DevPreviewSignalAnalysis'));

function App() {
  useEffect(() => {
    const sessionValid = initSessionTracking();
    if (sessionValid) {
      checkAuthVersion();
      refreshUserPermissions();
    }
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {process.env.NODE_ENV === 'development' && <Route path="/dev-preview/allocation" element={<Suspense fallback={null}><DevPreview /></Suspense>} />}
      {process.env.NODE_ENV === 'development' && <Route path="/dev-preview/jump" element={<Suspense fallback={null}><DevPreviewJump /></Suspense>} />}
      {process.env.NODE_ENV === 'development' && <Route path="/dev-preview/best-trades" element={<Suspense fallback={null}><DevPreviewBestTrades /></Suspense>} />}
      {process.env.NODE_ENV === 'development' && <Route path="/dev-preview/compare" element={<Suspense fallback={null}><DevPreviewCompare /></Suspense>} />}
      {process.env.NODE_ENV === 'development' && <Route path="/dev-preview/signal-brief" element={<Suspense fallback={null}><DevPreviewSignalBrief /></Suspense>} />}
      {process.env.NODE_ENV === 'development' && <Route path="/dev-preview/signal-analysis" element={<Suspense fallback={null}><DevPreviewSignalAnalysis /></Suspense>} />}
      <Route path="/" element={<Navigate to="/dashboard/today-status" replace />} />
      <Route
        path="/dashboard/:tab?"
        element={
          <ProtectedRoute requiredPage="dashboard">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/:tab?"
        element={
          <ProtectedRoute requiredPage="settings">
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/indexes"
        element={
          <ProtectedRoute requiredPage="indexes">
            <Indexes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/:topTab?/:subTab?"
        element={
          <ProtectedRoute requiredPage="reports">
            <Reports />
          </ProtectedRoute>
        }
      />
      <Route
        path="/strategy/:subTab?"
        element={
          <ProtectedRoute>
            <Reports />
          </ProtectedRoute>
        }
      />
      <Route path="/simulator" element={<ChartSimulator />} />
    </Routes>
  );
}

export default App;
